import styled from 'styled-components';
import { mediaQuery } from '../../../../theme/breakpoints';

type ContainerPropsType = {
  backgroundColor?: string;
  maxWidth?: string;
  width?: string;
  padding?: string;
  borderRadius?: string;
  mobileWidth?: string;
  mobileMargin?: string;
  tabletWidth?: string;
};

export const Container = styled.div<ContainerPropsType>`
  max-width: ${(p) => p.maxWidth};
  width: ${(p) => p.width};
  background: ${(p) => p.backgroundColor};
  padding: ${(p) => p.padding};
  border-radius: ${(p) => p.borderRadius};

  @media ${mediaQuery.medium} {
    width: ${(p) => p.tabletWidth};
  }

  @media ${mediaQuery.small} {
    width: ${(p) => p.mobileWidth};
    margin: ${(p) => p.mobileMargin};
  }
`;

export const FlexContainer = styled(Container)`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  margin: 0 auto;
`;
